export { default } from './B2BOrgLayout';
